import axios from '@/axios';

const RESOURCE_NAME = '/helper-items';

export default {
    getItems(page, filter = '') {
        return axios.get(`${RESOURCE_NAME}/get-items?page=${page}&filter=${filter}`)
    },
}
